<template>
  <div class="banner-wrap" id="bannerBox" :style="{ height: height + 'px' }">
   <div class="banner-bg" :style="{ height: height + 'px' }">
     <canvas id="canvas" class="canvas-box"></canvas>
     <div class="banner-bg-cover" :class="'banner-bg-' + (navIndex)"></div>
     <div class="show-box">
       <navigation :navIndex="navIndex"></navigation>
       <slot name="banner"></slot>
     </div>
   </div>
  </div>
</template>

<script>

import navigation from '@/components/navigation'
import BannerBg from "@/assets/home-banner-bg.jpg"

var bannerBoxDom,canvas, scene, renderer, camera, mouse, backgroundTexture, vShader, fShader, quad;
var timer = null;
export default {
  components: {
    navigation,
  },
  props: {
    navIndex: {},
    height: {
      type: Number,
      default: 900
    }
  },
  mounted() {
    if(this.navIndex === 0) {
      this.$nextTick(() => {
        this.initAnimation()
      })
    }
  },
  destroyed() {
    if(this.navIndex === 0) {
      bannerBoxDom.removeEventListener('mousemove',this.onMouseMove)
      bannerBoxDom.removeEventListener('touchmove',this.onTouchMove)
    }
  },
  methods: {
    fnThrottle(fn,interval = 0){
      let that = this
      return function () {
        if(timer)return
        timer = setTimeout(() => {
          let _arg = arguments
          timer = null
          fn.apply(that,_arg)
        },interval)
      }
    },
    throttleMouseMove(e){
      this.fnThrottle(this.onMouseMove)(e)
    },
    onResize() {
      renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
      camera.aspect = canvas.clientWidth / canvas.clientHeight;
      camera.updateProjectionMatrix();
    },
    onMouseMove(e) {
      var x = e.clientX / (window.innerWidth * 0.5) - 1;
      var y = -1 * (e.clientY / (window.innerHeight * 0.5)) + 1;
      this.updateMouse(x, y);
      console.log(1)
    },
    updateMouse(x, y) {
      try {
        // eslint-disable-next-line no-undef
        TweenLite.to(mouse, 2, {
          x: x, y: y, onUpdate: function onUpdate() {
            quad.material.uniforms.mouse.value = mouse;
          }
        });
      } catch (e) {
      }
    },
    onTouchMove(e) {
      var x = e.touches[0].clientX / (window.innerWidth * 0.5) - 1;
      var y = -1 * (e.touches[0].clientY / (window.innerHeight * 0.5)) + 1;
      this.updateMouse(x, y);
    },
    initAnimation() {
      canvas = document.getElementById('canvas');
      bannerBoxDom = document.getElementById('bannerBox');
      if (!canvas) return;
      scene = new THREE.Scene();
      renderer = new THREE.WebGLRenderer({canvas: canvas, antialias: true});
      camera = new THREE.PerspectiveCamera(45, canvas.clientWidth / canvas.clientWidth, 1, 1000);
      mouse = new THREE.Vector2(0.2, 0.4);
      backgroundTexture = new THREE.TextureLoader().load(BannerBg, function () {
        canvas.parentNode.classList.add('canvas-load');
      });
      vShader = "\n  varying vec2 vUv;\n\n  void main() {\n    vUv = uv;\n    gl_Position = vec4(position, 1.0);\n  }\n";
      fShader = "\n  varying vec2 vUv;\n  uniform sampler2D background;\n  uniform float delta;\n  uniform vec2 mouse;\n  uniform float speed;\n  \n  // Classic Perlin 3D Noise \n  // by Stefan Gustavson\n  //\n  vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}\n  vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}\n  vec3 fade(vec3 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}\n\n  float cnoise(vec3 P){\n    vec3 Pi0 = floor(P); // Integer part for indexing\n    vec3 Pi1 = Pi0 + vec3(1.0); // Integer part + 1\n    Pi0 = mod(Pi0, 289.0);\n    Pi1 = mod(Pi1, 289.0);\n    vec3 Pf0 = fract(P); // Fractional part for interpolation\n    vec3 Pf1 = Pf0 - vec3(1.0); // Fractional part - 1.0\n    vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);\n    vec4 iy = vec4(Pi0.yy, Pi1.yy);\n    vec4 iz0 = Pi0.zzzz;\n    vec4 iz1 = Pi1.zzzz;\n\n    vec4 ixy = permute(permute(ix) + iy);\n    vec4 ixy0 = permute(ixy + iz0);\n    vec4 ixy1 = permute(ixy + iz1);\n\n    vec4 gx0 = ixy0 / 7.0;\n    vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;\n    gx0 = fract(gx0);\n    vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);\n    vec4 sz0 = step(gz0, vec4(0.0));\n    gx0 -= sz0 * (step(0.0, gx0) - 0.5);\n    gy0 -= sz0 * (step(0.0, gy0) - 0.5);\n\n    vec4 gx1 = ixy1 / 7.0;\n    vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;\n    gx1 = fract(gx1);\n    vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);\n    vec4 sz1 = step(gz1, vec4(0.0));\n    gx1 -= sz1 * (step(0.0, gx1) - 0.5);\n    gy1 -= sz1 * (step(0.0, gy1) - 0.5);\n\n    vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);\n    vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);\n    vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);\n    vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);\n    vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);\n    vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);\n    vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);\n    vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);\n\n    vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));\n    g000 *= norm0.x;\n    g010 *= norm0.y;\n    g100 *= norm0.z;\n    g110 *= norm0.w;\n    vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));\n    g001 *= norm1.x;\n    g011 *= norm1.y;\n    g101 *= norm1.z;\n    g111 *= norm1.w;\n\n    float n000 = dot(g000, Pf0);\n    float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));\n    float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));\n    float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));\n    float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));\n    float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));\n    float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));\n    float n111 = dot(g111, Pf1);\n\n    vec3 fade_xyz = fade(Pf0);\n    vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);\n    vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);\n    float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); \n    return 2.2 * n_xyz;\n  }\n\n  void main() {\n    float delta = delta * 0.001 * speed;\n    float x = cnoise(vec3(vUv * (mouse.x * 2.0), delta));\n    float y = cnoise(vec3(vUv * (mouse.y * 2.0), delta));\n    x = (x * 0.6) + vUv.x;\n    y = (y * 0.6) + vUv.y;\n    vec4 texturePixel = texture2D(background, vec2(x, y));\n    \n    gl_FragColor = texturePixel;\n  }\n";
      quad = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), new THREE.ShaderMaterial({
        vertexShader: vShader,
        fragmentShader: fShader,
        depthWrite: false,
        depthTest: false,
        uniforms: {
          background: {type: 't', value: backgroundTexture},
          delta: {value: 1.0},
          mouse: {value: mouse},
          speed: {value: 0.25}
        }
      }));
      scene.add(quad);


      function render(a) {
        requestAnimationFrame(render);
        quad.material.uniforms.delta.value = a;
        renderer.render(scene, camera);
      }

      this.onResize();
      bannerBoxDom.addEventListener('resize', this.onResize);
      bannerBoxDom.addEventListener('mousemove', this.onMouseMove);
      // window.addEventListener('touchmove', this.onTouchMove);
      render();
    }
  }
}
</script>

<style scoped>
.banner-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 900px;
  z-index: 1;
  background-image: linear-gradient(to top left, #814e54, #545f65, #8cafb8);
}
.banner-wrap {
  height: 900px;
}

.canvas-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.banner-bg-cover {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: none;
  /*background-size:100% 100%;*/
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.banner-bg-1 {
  display: block;
  background-image: url(../../assets/banner_1.png);
}
.banner-bg-2 {
  display: block;
  background-image: url(../../assets/banner_2.png);
}
.banner-bg-3 {
  display: block;
  background-image: url(../../assets/banner_3.png);
}
.banner-bg-4 {
  display: block;
  background-image: url(../../assets/banner_4.png);
}
.show-box {
  position: relative;
  z-index: 2;
}
</style>
